import { Injectable } from '@angular/core';
import { countriesCurrencies } from 'src/app/_utlis/countries-currencies';
export interface CurrencyInfo {
  code: string;
  name: string;
  country: string;
  countryCode: string;
  flag?: string;
}
@Injectable({
  providedIn: 'root',
})
export class CurrencyService {
  private currencyMap: Map<string, CurrencyInfo>;

  constructor() {
    // Create a map for quick lookups
    this.currencyMap = new Map(
      countriesCurrencies.map((currency) => [currency.code, currency])
    );
  }

  getCurrencyInfo(code: string): CurrencyInfo | undefined {
    return this.currencyMap.get(code);
  }
}
